import { lazy } from 'react';

// project-imports
import Loadable from 'components/Loadable';
import { SimpleLayoutType } from 'config';
import PagesLayout from 'layout/Pages';
import SimpleLayout from 'layout/Simple';
import useAuth from 'hooks/useAuth';

// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/error/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/error/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction')));
const MaintenanceUnderConstruction2 = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction2')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon/coming-soon')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('pages/maintenance/coming-soon/coming-soon2')));

// render - sample page
const DashboardPage = Loadable(lazy(() => import('pages/dashboard')));
const DashboardUserPage = Loadable(lazy(() => import('pages/dashboard/dashboardUser')))
const UserPage = Loadable(lazy(() => import('pages/user')));
const UserFormPage = Loadable(lazy(() => import('pages/user/userForm')));
const IndexSettingPage = Loadable(lazy(() => import('pages/index-setting')));
const IndexSettingFormPage = Loadable(lazy(() => import('pages/index-setting/indexSettingForm')));

// ==============================|| MAIN ROUTES ||============================== //

const DashboardRoute = () => {
  const { user } = useAuth();
  return user?.role === "admin" ? <DashboardPage /> : <DashboardUserPage />;
};

const UserIndexElement = () => {
  const { user } = useAuth();
  return user?.role === "admin" ? <UserPage /> : <MaintenanceError />;
};

const UserFormElement = ({ isEdit, isUser }: { isEdit: boolean, isUser?: boolean }) => {
  const { user } = useAuth();
  return user?.role === "admin" || isUser ? <UserFormPage isEdit={isEdit} isUser={isUser} /> : <MaintenanceError />;
};

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: 'dashboard',
          element: <DashboardRoute />
        }
      ]
    },
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: 'users',
          children: [
            {
              index: true,
              element: <UserIndexElement />
            },
            {
              path: 'add',
              element: <UserFormElement isEdit={false} isUser={false} />
            },
            {
              path: 'edit',
              element: <UserFormElement isEdit={true} isUser={false} />
            },
            {
              path: '*',
              element: <MaintenanceError />
            }
          ]
        },
      ]
    },
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: 'settings',
          children: [
            {
              index: true,
              element: <IndexSettingPage />
            },
            {
              path: 'add',
              element: <IndexSettingFormPage isEdit={false} />
            },
            {
              path: 'edit',
              element: <IndexSettingFormPage isEdit={true} />
            },
            {
              path: '*',
              element: <MaintenanceError />
            }
          ]
        }
      ]
    },
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: 'profile',
          element: <UserFormElement isEdit={true} isUser={true} />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'under-construction2',
          element: <MaintenanceUnderConstruction2 />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        },
        {
          path: 'coming-soon-2',
          element: <MaintenanceComingSoon2 />
        }
      ]
    },
    { path: '*', element: <MaintenanceError /> }
  ]
};

export default MainRoutes;
